
const CampaignNotifications = () => {
  return (
    <>
    </>
  );
}

export default CampaignNotifications;
